export var spinnerPortalTokens = {
  variants: {
    dark: {
      fg: function fg(_ref) {
        var palette = _ref.palette;
        return palette.neutralsBlack.hex50;
      },
      bg: function bg(_ref2) {
        var palette = _ref2.palette;
        return palette.neutralsBlack.rgba20;
      }
    },
    light: {
      fg: function fg(_ref3) {
        var palette = _ref3.palette;
        return palette.neutralsWhite.hex100;
      },
      bg: function bg(_ref4) {
        var palette = _ref4.palette;
        return palette.neutralsWhite.rgba20;
      }
    }
  },
  sizes: {
    s: "16px",
    m: "20px",
    l: "24px",
    xl: "56px",
    xxl: "90px"
  }
};